import { render, staticRenderFns } from "./delivery_list.vue?vue&type=template&id=881ebea6&scoped=true"
import script from "./delivery_list.vue?vue&type=script&lang=js"
export * from "./delivery_list.vue?vue&type=script&lang=js"
import style0 from "./delivery_list.vue?vue&type=style&index=0&id=881ebea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ebea6",
  null
  
)

export default component.exports